var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"4","height":"11","viewBox":"0 0 4 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.862 11H3.878V0.794H0.504V2.6H1.862V11Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }